import { Eye } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import { SessionManager } from '../../utils'

export default function ActionDetails(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name === route_name) &&
                <Eye size={16} className='action_btn text-primary me-3'
                    onClick={onClick}
                    data-tooltip-id='details'
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                />
            }

            <Tooltip id='details' className='bg-primary tooltip_msg' />
        </>
    )
}
